import { styled } from '@mui/material/styles';

export const StyledTextEllipsis = styled('div')`
  display: block;
  width: 200px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
